import type { Components, Theme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';
import type { DataGridProProps } from '@mui/x-data-grid-pro';

const UNSORTED_HOVERED_SORT_BUTTON =
  '& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):hover .MuiDataGrid-sortButton';

// MUI X 8 adds a scroll shadow beside pinned columns and rows; MUI X 7 drew
// only the border. The theme types MuiDataGrid props as the community grid's,
// which has neither prop.
export const MUI_X_7_GRID_PROPS: Pick<
  DataGridProProps,
  'pinnedColumnsSectionSeparator' | 'pinnedRowsSectionSeparator'
> = {
  pinnedColumnsSectionSeparator: 'border',
  pinnedRowsSectionSeparator: 'border',
};

// The style function runs for every MuiDataGrid slot, and only the root slot
// passes the grid props as ownerState.
export const MUI_X_7_LOOK: Components<Theme> = {
  MuiDataGrid: {
    styleOverrides: {
      root: ({ ownerState, theme }) => ({
        ...(ownerState?.showToolbar
          ? {}
          : {
              '& [aria-rowindex="1"] [aria-colindex="1"]': {
                borderTopLeftRadius:
                  'calc(var(--unstable_DataGrid-radius) - 1px)',
              },
            }),
        '& .MuiDataGrid-columnHeader .MuiDataGrid-sortButton': {
          backgroundColor: 'transparent',
        },
        '@media (hover: hover)': {
          '& .MuiDataGrid-columnHeader .MuiDataGrid-sortButton:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          [UNSORTED_HOVERED_SORT_BUTTON]: {
            opacity: 0.5,
          },
          [`${UNSORTED_HOVERED_SORT_BUTTON} > *`]: {
            opacity: 1,
          },
        },
      }),
    },
  },
};
